const colorData = {
  "Believe": "#c54c48",
  "Conquer": "#ab584b",
  "Convince": "#ae4640",
  "Dominate": "#c54e48",
  "ABU": "#808080",
  "ABU-ABU": "#808080",
  "ALL BLACK": "#000000",
  "ALMOND": "#efdecd",
  "APPRICOT": "#fbceb1",
  "APRICOT": "#fbceb1",
  "APRICOT BRANDY": "#C46858",
  "AQUA": "#00FFFF",
  "ARGAN OIL": "#8b593e",
  "ASSORTED": "#ffffff",
  "ASSORTIVE COLOR": "#ffffff",
  "AVOCADO": "#568203",
  "AZURE": "#007FFF",
  "AZURE/BLUE": "#4682BF",
  "AZURE/BROWN": "#007FFF",
  "AZURE/GREY": "#007efe",
  "AZURE/WHITE": "#ffffff",
  "Baby Blue": "#89cff0",
  "BABY BLUE": "#0099ff",
  "BABY PINK": "#f4c2c2",
  "BABY PURPLE": "#ca9bf7",
  "BABY YELLOW": "#f8e5b7",
  "BAMBO": "#d56005",
  "BANANA": "#ffe135",
  "BANANA CREAM": "#fce5b9",
  "BAROQUE ROSE": "#b35a66",
  "BEGIE GOLD": "#f5f5dc",
  "BEIGE": "#f5f5dc",
  "BEIGE BLACK": "#d9b382",
  "BEIGE BLUE": "#f5f5dc",
  "BEIGE BONE": "#e3dac9",
  "BEIGE BROWN": "#AF804F",
  "BEIGE FUCHIA": "#f5f5dc",
  "BEIGE GREEN": "#f5f5dc",
  "BEIGE GREY": "#f5f5dc",
  "BEIGE MAROON": "#f5f5dc",
  "BEIGE NAVY": "#f5f5dc",
  "BEIGE OLIVE": "#f5f5dc",
  "BEIGE ORANGE": "#f5f5dc",
  "BEIGE PINK": "#f5f5dc",
  "BEIGE RED": "#f5f5dc",
  "BEIGE SILVER": "#f5f5dc",
  "BEIGE WHITE": "#f5f5dc",
  "BEIGE YELLOW": "#f5f5dc",
  "BIRU": "#0000ff",
  "BLACK BEAN": "#3d0c02",
  "BLACK BEAUTY": "#3a3837",
  "BLACK BEIGE": "#d9b382",
  "BLACK BLUE": "#00008b",
  "BLACK BONE": "#bab9af",
  "BLACK BROWN": "#654321",
  "BLACK CHECK": "#000000",
  "BLACK CREAM": "#fff39a",
  "BLACK FOREST": "#2C3227",
  "BLACK FUCHIA": "#a00c61",
  "BLACK GOLD": "#fbfcd4",
  "BLACK GREEN": "#013220",
  "BLACK GREY": "#a9a9a9",
  "BLACK IRIS": "#2b3042",
  "BLACK MAROON": "#2f0909",
  "BLACK NAVY": "#02075d",
  "BLACK OLIVE": "#3b3c36",
  "BLACK ORANGE": "#ff8c00",
  "BLACK PINK": "#e75480",
  "BLACK RED": "#8b0000",
  "BLACK SILVER": "#666664",
  "BLACK WHITE": "#E7E6DD",
  "BLACK YELLOW": "#9B870C",
  "BLACK-STRIPED AZURE": "#000000",
  "BLACK-STRIPED BLUE": "#000000",
  "BLACK-STRIPED BROWN": "#000000",
  "BLACK-STRIPED GREY": "#000000",
  "BLACK-STRIPED RED": "#000000",
  "BLACK-STRIPED WHITE": "#000000",
  "BLACK-STRIPED YELLOW": "#000000",
  "BLACK/BLUE": "#00008b",
  "BLACK/BLUE CHECK": "#000000",
  "BLACK/BROWN": "#654321",
  "BLACK/GREEN": "#013220",
  "BLACK/GREY": "#a9a9a9",
  "BLACK/LT BLUE": "#000000",
  "BLACK/ORANGE": "#ff8c00",
  "BLACK/ORANGE CHECK": "#000000",
  "BLACK/PINK": "#e75480",
  "BLACK/PINK CHECK": "#000000",
  "BLACK/RED": "#8b0000",
  "BLACK/RED CHECK": "#000000",
  "BLACK/VIOLET": "#000000",
  "BLACK/WHITE": "#E7E6DD",
  "BLACK/WHITE CHECK": "#000000",
  "BLACK/YELLOW": "#9B870C",
  "BLANC DE BLANC": "#E9EAE8",
  "BLEACH": "#FEEFD6",
  "BLUE": "#0000ff",
  "BLUE BEIGE": "#0000ff",
  "BLUE BLACK": "#00008b",
  "BLUE BROWN": "#0000ff",
  "BLUE CHECK": "#0000ff",
  "BLUE FUCHIA": "#7e57c2",
  "BLUE GOLD": "#D5Ad36",
  "BLUE GREEN": "#0d98ba",
  "BLUE GREY": "#6699cc",
  "BLUE MAROON": "#0000ff",
  "BLUE NAVY": "#000080",
  "BLUE OLIVE": "#0000ff",
  "BLUE ORANGE": "#2081f9",
  "BLUE PINK": "#0000ff",
  "BLUE RED": "#0000ff",
  "BLUE SILVER": "#0000ff",
  "BLUE STEEL": "#4682b4",
  "BLUE WHITE": "#F5FAFA",
  "BLUE YELLOW": "#235789",
  "BLUE-STRIPED GREY": "#0000ff",
  "BLUE-STRIPED ORANGE": "#0000ff",
  "BLUE-STRIPED RED": "#0000ff",
  "BLUE-STRIPED WHITE": "#0000ff",
  "BLUE-STRIPED YELLOW": "#0000ff",
  "BLUE/BLACK": "#00008b",
  "BLUE/BLACK CHECK": "#0000ff",
  "BLUE/BROWN": "#0000ff",
  "BLUE/BROWN CHECK": "#0000ff",
  "BLUE/GREEN": "#0d98ba",
  "BLUE/GREEN CHECK": "#0000ff",
  "BLUE/GREY": "#6699cc",
  "BLUE/GREY CHECK": "#0000ff",
  "BLUE/LT BLUE": "#0000ff",
  "BLUE/LT BLUE CHECK": "#0000ff",
  "BLUE/ORANGE": "#2081f9",
  "BLUE/PINK": "#0000ff",
  "BLUE/RED": "#0000ff",
  "BLUE/RED CHECK": "#0000ff",
  "BLUE/VIOLET": "#8A2BE2",
  "BLUE/VIOLET CHECK": "#0000ff",
  "BLUE/WHITE": "#F5FAFA",
  "BLUE/WHITE CHECK": "#0000ff",
  "BLUE/YELLOW": "#235789",
  "BLUE/YELLOW CHECK": "#0000ff",
  "BLUSH": "#de5d83",
  "BRANDY": "#E0CC97",
  "BRIGHT GREEN": "#66ff00",
  "BRIGHT WHITE": "#f4f5f0",
  "BRILLIANT BLUE": "#1a5fa1",
  "BROKEN WHITE": "#f4dfb9",
  "BRONZE": "#cd7f32",
  "BROWN": "#964B00",
  "BROWN BEIGE": "#af804f",
  "BROWN BLACK": "#654321",
  "BROWN CHECK": "#A52A2A",
  "BROWN CREAM": "#FFFDDD",
  "BROWN GOLD": "#cb7e1f",
  "BROWN KHAKI": "#c0ad8c",
  "BROWN OFF WHT": "#cb7e1f",
  "BROWN ORANGE": "#996600",
  "BROWN SUGAR": "#af6e4d",
  "BROWN WHITE": "#cb7e1f",
  "BROWN YELLOW": "#cc9966",
  "BROWN-STRIPED BLACK": "#cb7e1f",
  "BROWN-STRIPED BLUE": "#cb7e1f",
  "BROWN-STRIPED WHITE": "#cb7e1f",
  "BROWN/BLACK": "#654321",
  "BROWN/BLACK CHECK": "#cb7e1f",
  "BROWN/BLUE": "#cb7e1f",
  "BROWN/BLUE CHECK": "#cb7e1f",
  "BROWN/GREEN": "#cb7e1f",
  "BROWN/GREY": "#A52A2A",
  "BROWN/ORANGE": "#996600",
  "BROWN/ORANGE CHECK": "#A52A2A",
  "BROWN/PINK": "#A52A2A",
  "BROWN/WHITE": "#A52A2A",
  "BROWN/WHITE CHECK": "#cb7e1f",
  "BROWN/YELLOW": "#cc9966",
  "BUBBLEGUM PINK": "#ffc1cc",
  "BUFF": "#f0dc82",
  "BUFF GREY": "#808080",
  "BUFF ORANGE": "#ffa600",
  "BURGUNDY": "#800020",
  "BUTTERCREAM": "#efe0cd",
  "BW SLUB": "#ffffff",
  "CACTUS GREEN": "#237543",
  "CAMEL": "#c19a6b",
  "CARAMEL": "#85461e",
  "CARMINE": "#99001C",
  "CERAMIC": "#FBFFF4",
  "CHAMB": "#000000",
  "CHAMPAGNE": "#f7e7ce",
  "CHARCOAL": "#36454f",
  "CHARCOAL CEDAR": "#808080",
  "CHARCOAL GREEN": "#808080",
  "CHARCOAL SULFUR": "#808080",
  "CHERRY BLOSSOM": "#ffb7c5",
  "CHOCOLATE": "#d2691e",
  "CHRISTMAS GREEN": "#3C8D0D",
  "CINDER SULFUR": "#151422",
  "CLASSIC BLUE": "#0f4c81",
  "CLASSIC GREEN": "#b4e5af",
  "CLASSIC ORANGE": "#ffb162",
  "CLASSIC PURPLE": "#9192c9",
  "CLASSIC RED": "#bf3c41",
  "CLASSIC YELLOW": "#f4b800",
  "COBALT BLUE": "#0047ab",
  "COCO BROWN": "#35281E",
  "COFFEE": "#6f4e37",
  "COKLAT": "#d2691e",
  "COPPER": "#b87333",
  "CORAL": "#ff7f50",
  "CORONET BLUE": "#a3cfdb",
  "CREAM": "#FFFDD0",
  "CREAM BROWN": "#FFFDDD",
  "CREAM OLIVE": "#fffdd0",
  "CREAM PINK": "#f3e5dc",
  "CREAM TAN": "#e3c6b4",
  "CRYSTAL ROSE": "#fdc3c6",
  "D.EXPLOR SULFUR": "#fffdd0",
  "D.PINK": "#FFC0CB",
  "DARK BEIGE": "#d9b382",
  "DARK BLUE": "#00008b",
  "DARK BLUE GREY": "#666699",
  "DARK BRONZE": "#804a00",
  "DARK BROWN": "#654321",
  "DARK DENIM": "#35485E",
  "DARK GOLD": "#aa6c39",
  "DARK GREEN": "#006400",
  "DARK GREY": "#A9A9A9",
  "DARK JADE": "#09363c",
  "DARK MAROON": "#330000",
  "DARK MISTY": "#A0AFB7",
  "DARK NAVY": "#02075d",
  "DARK ORANGE": "#FF8C00",
  "DARK PINK": "#e75480",
  "DARK PURPLE": "#301934",
  "DARK RED": "#8B0000",
  "DARK SILVER": "#706F6D",
  "DARK YELLOW": "#9B870C",
  "DEEP RED": "#8b0000",
  "DEEP ROYAL": "#1560bd",
  "DEEP SEA": "#177C72",
  "DENIM": "#1560BD",
  "DESSERT SAND": "#edc9af",
  "DUCK EGG BLUE": "#cae8dc",
  "DUSTY GREEN": "#70a370",
  "DUSTY PINK": "#d59696",
  "DUSTY PURPLE": "#865f84",
  "DUSTY ROSE": "#c57076",
  "ECRU": "#C2B280",
  "EGG PLANT": "#614051",
  "EGGPLANT": "#614051",
  "EMAS": "#FFD700",
  "EMERALD GREEN": "#046307",
  "EXPLORER SULFUR": "#FFC832",
  "FANTA": "#ff0000",
  "FOG": "#dcd0ff",
  "FOREST GREEN": "#228B22",
  "FRENCH BLUE": "#0072bb",
  "FROST GRAY": "#848283",
  "FROST GREY": "#848283",
  "FUCHIA": "#FF00FF",
  "FUCHIA BLACK": "#a00c61",
  "FUCHIA PINK": "#ff77ff",
  "FUSCHIA": "#FF00FF",
  "GARNET": "#733635",
  "GINGER BREAD": "#8c4a2f",
  "GOLD": "#ffd900",
  "GOLD BLACK": "#aa6c39",
  "GOLD SILVER": "#ffd900",
  "GOLD WHITE": "#bba58e",
  "GOLDEN BROWN": "#996515",
  "GRAPE": "#6f2da8",
  "GRAPE WHITE": "#6f2da8",
  "GRAPIT": "#251607",
  "GRASS GREEN": "#567d46",
  "GREEN": "#008000",
  "GREEN ARMY": "#4b5320",
  "GREEN BEGIE": "#d2e8ba",
  "GREEN BLACK": "#013220",
  "GREEN BOOMBOGIE": "#008000",
  "GREEN DEEP SEA": "#265557",
  "GREEN LIME": "#32CD32",
  "GREEN MOSS": "#8a9a5b",
  "GREEN TOSCA": "#2ED1A2",
  "GREEN WHITE": "#D9D9CC",
  "GREEN-STRIPED WHITE": "#008000",
  "GREEN/BLACK": "#013220",
  "GREEN/BLUE": "#1164b4",
  "GREEN/GREY": "#9CA89C",
  "GREEN/PINK": "#008000",
  "GREEN/RED": "#008000",
  "GREEN/VIOLET": "#008000",
  "GREEN/WHITE": "#D9D9CC",
  "GREEN/WHITE CHECK": "#008000",
  "GREEN/YELLOW": "#adff2f",
  "GREY": "#808080",
  "GREY BLACK": "#A9A9A9",
  "GREY BROWN": "#3d3635",
  "GREY CHECK": "#808080",
  "GREY FUCHIA": "#FF00FF",
  "GREY GOLD": "#787160",
  "GREY GREEN": "#636B59",
  "GREY NAVI": "#070b47",
  "GREY ORANGE": "#fe5800",
  "GREY PINK": "#c3909b",
  "GREY RED": "#808080",
  "GREY SILVER": "#808080",
  "GREY-STRIPED BLUE": "#6699cc",
  "GREY-STRIPED WHITE": "#808080",
  "GREY/BLACK": "#A9A9A9",
  "GREY/BLACK CHECK": "#808080",
  "GREY/BLUE": "#6699cc",
  "GREY/GREEN": "#636B59",
  "GREY/ORANGE": "#fe5800",
  "GREY/PINK": "#c3909b",
  "GREY/PINK CHECK": "#808080",
  "GREY/RED": "#808080",
  "GREY/WHITE": "#ff0000",
  "GREY/WHITE CHECK": "#808080",
  "GREY/YELLOW": "#958F79",
  "GUM PURPLE": "#501563",
  "GUN": "#808080",
  "HAWAIIAN OCEAN": "#008db9",
  "HIJAU": "#008000",
  "HITAM": "#000000",
  "HONEY SOCKLE": "#EAE86F",
  "HOSPITAL GREEN": "#9be5aa",
  "HOT PINK": "#FF69B4",
  "INCENSE": "#825144",
  "INDIGO": "#4B0082",
  "INDIGO BLUE": "#3964C3",
  "IVORY": "#FFFFF0",
  "JADE": "#00a86b",
  "JEANS": "#1560bd",
  "JELLY GREEN": "#DA614E",
  "JUKE GREEN": "#00a86b",
  "KETCHUP": "#c82922",
  "KHAKI": "#F0E68C",
  "KHAKY": "#F0E68C",
  "KHAKY GREEN": "#728639",
  "KNOCKOUT PINK": "#FF3EA5",
  "KREM": "#fffdd0",
  "KUNING": "#FFFF00",
  "LAVENDER": "#E6E6FA",
  "LEMON": "#fff700",
  "LIGHT BLACK": "#000000",
  "LIGHT BLUE": "#ADD8E6",
  "LIGHT BROWN": "#b5651d",
  "LIGHT CORAL": "#F08080",
  "LIGHT DENIM": "#1560bd",
  "LIGHT GOLD": "#b29700",
  "LIGHT GREEN": "#90EE90",
  "LIGHT GREY": "#D3D3D3",
  "LIGHT KHAKY": "#ab9370",
  "LIGHT MISTY": "#A0AFB7",
  "LIGHT ORANGE": "#ffb347",
  "LIGHT PINK": "#FFB6C1",
  "LIGHT PURPLE": "#b19cd9",
  "LIGHT RED": "#ff6961",
  "LIGHT TEAL": "#008080",
  "LIGHT YELLOW": "#FFFFE0",
  "LILAC": "#c8a2c8",
  "LIME": "#00FF00",
  "LIVING CORAL": "#FA7268",
  "LT BLUE-STRIPED BLUE": "#ADD8E6",
  "LT BLUE-STRIPED BROWN": "#ADD8E6",
  "LT BLUE-STRIPED WHITE": "#ADD8E6",
  "LT GREEN-STRIPED GREEN": "#90EE90",
  "LUPINE": "#bea0c8",
  "MAGENTA": "#FF00FF",
  "MANDARIN ORANGE": "#E9693D",
  "MAROON": "#800000",
  "MAROON NAVY": "#800000",
  "MAROON WHITE": "#800000",
  "MARUN": "#800000",
  "MED GREEN": "#3cb371",
  "MEDIUM BLUE": "#0000CD",
  "MEDIUM DENIM": "#1560bd",
  "MEDIUM LIGHT BLUE": "#ADD8E6",
  "MEDIUM PINK": "#f35390",
  "MELON": "#fdbcb4",
  "MERAH": "#FF0000",
  "MERCURE GREY": "#808080",
  "MERCURY": "#d5d2d1",
  "MERRYGOLD": "#FFD700",
  "MIDLE BLUE": "#0000cd",
  "MILK": "#fdfff5",
  "MILKY BLUE": "#add8e6",
  "MILLITARY": "#4b5320",
  "MILO": "#575757",
  "MINT": "#3EB489",
  "MINTY GREEN": "#98FF98",
  "MISTY": "#808080",
  "MISTY BLUE": "#a0afb7",
  "MISTY DARK BLUE": "#00008B",
  "MISTY DARK BROWN": "#654321",
  "MISTY DARK GREEN": "#006400",
  "MISTY DARK GREY": "#A9A9A9",
  "MISTY DARK KHAKI": "#BDB76B",
  "MISTY DARK MAROON": "#8B0000",
  "MISTY DARK ORANGE": "#FF8C00",
  "MISTY DARK PURPLE": "#9400D3",
  "MISTY DARK RED": "#8B0000",
  "MISTY DARK YELLOW": "#9b870c",
  "MISTY GREY": "#808080",
  "MISTY KOMB NAVY": "#000080",
  "MISTY LIGHT BLUE": "#ADD8E6",
  "MISTY LIGHT BROWN": "#b5651d",
  "MISTY LIGHT GREEN": "#90EE90",
  "MISTY LIGHT GREY": "#D3D3D3",
  "MISTY LIGHT KHAKI": "#ab9370",
  "MISTY LIGHT MAROON": "#a24857",
  "MISTY LIGHT ORANGE": "#ffb347",
  "MISTY LIGHT PURPLE": "#b19cd9",
  "MISTY LIGHT RED": "#ff6961",
  "MISTY LIGHT YELLOW": "#FFFFE0",
  "MISTY MEDIUM BLUE": "#0000CD",
  "MISTY MEDIUM BROWN": "#b5651d",
  "MISTY MEDIUM GREEN": "#3cb371",
  "MISTY MEDIUM GREY": "#D3D3D3",
  "MISTY MEDIUM KHAKI": "#ab9370",
  "MISTY MEDIUM MAROON": "#a24857",
  "MISTY MEDIUM ORANGE": "#ffb347",
  "MISTY MEDIUM PURPLE": "#b19cd9",
  "MISTY MEDIUM RED": "#ff6961",
  "MISTY MEDIUM YELLOW": "#FFFFE0",
  "MIX": "#ffffff",
  "MOCCA": "#6F372D",
  "MOOD INDIGO": "#364051",
  "MUDDY GREEN": "#657432",
  "MULTI COLOR": "#ffffff",
  "MULTICOLOR": "#ffffff",
  "MULTICOLOUR": "#ffffff",
  "MULTICOLOUR STRIPED": "#ffffff",
  "MUSHROOM": "#BCABA0",
  "MUSTARD": "#ffdb58",
  "NAVY": "#000080",
  "NAVY BEIGE": "#000080",
  "NAVY BLUE": "#000080",
  "NAVY CREAM": "#000080",
  "NAVY GOLD": "#000080",
  "NAVY GREY": "#000080",
  "NAVY ORANGE": "#000080",
  "NAVY POPPY": "#000080",
  "NAVY RED": "#000080",
  "NAVY SILVER": "#000080",
  "NAVY WHITE": "#000080",
  "NAVY YELLOW": "#000080",
  "NEON GREEN": "#39ff14",
  "NEON ORANGE": "#ff3403",
  "NEON PINK": "#fe019a",
  "NEON YELLOW": "#cfff04",
  "NO COLOR": "#ffffff",
  "NUSS": "#f4f0db",
  "OFF WHITE": "#f4f0db",
  "OLD GOLD": "#cfb53b",
  "OLIVE": "#808000",
  "OLIVE BEIGE": "#808000",
  "OLIVE CREAM": "#808000",
  "OLIVE GREEN": "#808000",
  "OLIVE ORANGE": "#808000",
  "OLIVE YELLOW": "#808000",
  "ORANGE": "#ffa600",
  "ORANGE BAKAR": "#ffa600",
  "ORANGE SILVER": "#ffa600",
  "ORANGE SOFT": "#ffa600",
  "ORANGE WHITE": "#ffa600",
  "ORANGE-STRIPED BLUE": "#ffa600",
  "ORANGE-STRIPED BROWN": "#FFA500",
  "ORANGE/BLACK": "#FFA500",
  "ORANGE/BROWN": "#FFA500",
  "ORANGE/GREEN": "#ffa600",
  "ORANGE/GREY": "#FFA500",
  "ORANGE/WHITE": "#ffa600",
  "ORANYE": "#FFA500",
  "ORCHID": "#DA70D6",
  "PALE": "#db7093",
  "PALE PURPLE": "#979dbc",
  "PASTEL BLUE": "#80cee1",
  "PASTEL GREEN": "#77dd77",
  "PASTEL GREY": "#cfcfc4",
  "PASTEL LAVENDER": "#967BB6",
  "PASTEL ORANGE": "#ffb347",
  "PASTEL PINK": "#ffd0dc",
  "PASTEL PURPLE": "#b39eb5",
  "PASTEL YELLOW": "#fdfd96",
  "PEACH": "#db7093",
  "PEACOAT": "#2b2e43",
  "PEANUT": "#c6952b",
  "PEARL": "#eae0c8",
  "PELANGI": "#ffffff",
  "PEPPERMINT": "#d7e7d0",
  "PERAK": "#c0c0c0",
  "PEWTER": "#8e9294",
  "PINK": "#ffc0cb",
  "PINK BLACK": "#ffc0cb",
  "PINK CORAL": "#e5aaae",
  "PINK FUCHIA": "#e5aaae",
  "PINK GREY": "#ffc0cb",
  "PINK LADY": "#ffc0cb",
  "PINK LEMONADE": "#f2dbe7",
  "PINK PASTEL": "#ffd0dc",
  "PINK PURPLE": "#ffc0cb",
  "PINK RED": "#ffc0cb",
  "PINK SALEM": "#ffc0cb",
  "PINK SILVER": "#ffc0cb",
  "PINK WHITE": "#ffc0cb",
  "PINK-STRIPED WHITE": "#FFC0CB",
  "PINK/BLACK": "#ffc0cb",
  "PINK/BLUE": "#FFC0CB",
  "PINK/BLACK CHECK": "#ffc0cb",
  "PINK/BROWN": "#FFC0CB",
  "PINK/GREEN": "#FFC0CB",
  "PINK/GREY": "#FFC0CB",
  "PINK/LT BLUE": "#ffc0cb",
  "PINK/RED": "#FFC0CB",
  "PINK/VIOLET": "#ffc0cb",
  "PINK/WHITE": "#FFC0CB",
  "PINK/WHITE CHECK": "#FFC0CB",
  "PRINT": "#ffc0cb",
  "PUMPKIN": "#c29b00",
  "PURPLE": "#800080",
  "PURPLE BLUE": "#30106b",
  "PUTIH": "#ffffff",
  "RAINBOW": "#ffffff",
  "RASPBERRY": "#fc000d",
  "RED": "#f00c0c",
  "RED BLACK": "#a30a35",
  "RED BLUE": "#b81154",
  "RED NAVY": "#f70077",
  "RED PINK": "#ad0757",
  "RED WHITE": "#8a1c21",
  "RED WINE": "#000000",
  "RED-STRIPED BLUE": "#f00c0c",
  "RED-STRIPED WHITE": "#f00c0c",
  "RED/BLACK": "#8c0535",
  "RED/BLACK CHECK": "#f00c0c",
  "RED/BLUE": "#FF0000",
  "RED/BLUE CHECK": "#964755",
  "RED/BROWN": "#a21716",
  "RED/GREEN CHECK": "#f00c0c",
  "RED/GREY": "#d47b7e",
  "RED/ORANGE": "#f00c0c",
  "RED/PINK": "#f00c0c",
  "RED/VIOLET": "#d92095",
  "RED/WHITE": "#FF0000",
  "RED/WHITE CHECK": "#FF0000",
  "RINDE": "#f00c0c",
  "ROSE": "#f00c0c",
  "ROSE GOLD": "#f00c0c",
  "ROSE PINK": "#f00c0c",
  "ROYAL BLUE": "#4169e1",
  "RUBY RED": "#f00c0c",
  "RUSTIC BROWN": "#715d4c",
  "RUSTIC GOLD": "#AB8100",
  "RUSTIC ORANGE": "#a34730",
  "SABIA": "#a09c68",
  "SALEM": "#19fc20",
  "SALMON": "#fa8072",
  "SAND": "#c2b280",
  "SEA PINK": "#ed989e",
  "SESAME": "#f9f0d5",
  "SILVER": "#C0C0C0",
  "SILVER BALCK": "#c0c0c0",
  "SILVER BLUE": "#839CA5",
  "SILVER CARCOAL": "#686f77",
  "SILVER CEDAR": "#c0c0c0",
  "SILVER GRAY": "#BbC2C2",
  "SILVER GREY": "#b8b9b6",
  "SILVER MERCURRY": "#c0c0c0",
  "SILVER NAVY": "#c0c0c0",
  "SILVER PINK": "#c4aead",
  "SILVER RED": "#94575e",
  "SILVER WHITE": "#c0c0c0",
  "SKIP BLUE": "#86ceeb",
  "SKY BLUE": "#86ceeb",
  "SMOKE BROWN": "#af814f",
  "SOFT BLUE": "#ABD7EB",
  "SOFT GREEN": "#D5F5EE",
  "SOFT ORANGE": "#FF7E47",
  "SOFT PINK": "#fdb0c0",
  "SOFT PURPLE": "#a66fb5",
  "SOFT YELLOW": "#f4f186",
  "SPOT BLACK": "#000000",
  "SPOT BLUE": "#1100ff",
  "SPOT BROWN": "#954535",
  "SPRING YELLOW": "#e27b1c",
  "STONE": "#5e5e5e",
  "STRIPE BLACK GREY": "#00000b",
  "STRIPE BLACK RED": "#000000",
  "STRIPE GREEN": "#44ff00",
  "STRIPE GREY RED": "#7a757a",
  "STRIPE NAVY BLUE": "#000080",
  "STRIPE PINK": "#ff00d5",
  "SUMMER MELON": "#FCCDB4",
  "SUNNY LIME": "#DEEF87",
  "SUNSHINE YELLOW": "#FFF700",
  "TAN": "#D2B48C",
  "TAN BLACK": "#000000",
  "TAN BROWN": "#865d3f",
  "TANGERINE": "#f28500",
  "TAUPE": "#483c32",
  "TAUPE GREY": "#8b8589",
  "TAWNY OLIVE": "#c4962c",
  "TEAL": "#008080",
  "TERRACOTTA": "#e2725b",
  "TINK": "#062a2f",
  "TOMATO": "#ff6347",
  "TOSCA": "#744042",
  "TRIMBER": "#6a5141",
  "TRUE BLUE": "#0073cf",
  "TURQOISE": "#40E0D0",
  "TURQOUISE": "#40E0D0",
  "TURQUISE": "#40E0D0",
  "UNGU": "#800080",
  "VANILLA": "#f3e5ab",
  "VIBRANT YELLOW": "#fddb27",
  "VIOLET": "#EE82EE",
  "VIOLET-STRIPED YELLOW": "#EE82EE",
  "VIOLET/BLACK": "#421A4C",
  "VIOLET/BLUE": "#324ab2",
  "VIOLET/GREY": "#a7a6ba",
  "VIOLET/PINK": "#e03fd8",
  "VIOLET/RED": "#f75394",
  "VIOLET/WHITE": "#FEFCFF",
  "VIOLET/YELLOW": "#EE82EE",
  "WHITE": "#ffffff",
  "WHITE BEIGE": "#ffffff",
  "WHITE BLACK": "#E7E6DD",
  "WHITE BLUE": "#F6F6FF",
  "WHITE BROWN": "#ffffff",
  "WHITE BURGUNDY": "#ffffff",
  "WHITE CARCOAL": "#ffffff",
  "WHITE FUCHIA": "#FF0080",
  "WHITE GOLD": "#bba58e",
  "WHITE GREEN": "#a5ba93",
  "WHITE GREY": "#676767",
  "WHITE KHAKI": "#ffffff",
  "WHITE KOMB BLACK": "#E7E6DD",
  "WHITE KOMB MISTY": "#ffffff",
  "WHITE KOMB NAUTICA": "#ffffff",
  "WHITE MAROON": "#ffffff",
  "WHITE MERCURY": "#ffffff",
  "WHITE NAVY": "#ffffff",
  "WHITE OLIVE": "#dcd6b6",
  "WHITE ORANGE": "#FEFBEA",
  "WHITE PINK": "#FFE5E5",
  "WHITE PURPLE": "#ffffff",
  "WHITE RED": "#ffffff",
  "WHITE SILVER": "#ffffff",
  "WHITE TIMBER": "#ffffff",
  "WHITE YELLOW": "#ffffff",
  "WHITE-STRIPED AZURE": "#FFFFFF",
  "WHITE-STRIPED BLACK": "#FFFFFF",
  "WHITE-STRIPED BLUE": "#FFFFFF",
  "WHITE-STRIPED BROWN": "#FFFFFF",
  "WHITE-STRIPED GREEN": "#ffffff",
  "WHITE-STRIPED PINK": "#ffffff",
  "WHITE-STRIPED RED": "#ffffff",
  "WHITE/BLACK": "#FFFFFF",
  "WHITE/BLACK CHECK": "#ffffff",
  "WHITE/BLUE": "#FFFFFF",
  "WHITE/BLUE CHECK": "#FFFFFF",
  "WHITE/BROWN": "#FFFFFF",
  "WHITE/GREEN": "#ffffff",
  "WHITE/GREY": "#FFFFFF",
  "WHITE/GREY CHECK": "#ffffff",
  "WHITE/LT BLUE": "#FFFFFF",
  "WHITE/ORANGE": "#ffffff",
  "WHITE/PINK": "#FFFFFF",
  "WHITE/RED": "#FFFFFF",
  "WHITE/RED CHECK": "#FFFFFF",
  "WHITE/VIOLET": "#FFFFFF",
  "WHITE/YELLOW": "#FFFFFF",
  "WINE": "#722f37",
  "WOOD BROWN": "#C19A6B",
  "YELLOW": "#FFFF00",
  "YELLOW BLACK": "#ffff00",
  "YELLOW CREAM": "#ffff00",
  "YELLOW RED": "#ffff00",
  "YELLOW WHITE": "#ffff00",
  "YELLOW-STRIPED AZURE": "#ffff00",
  "YELLOW-STRIPED BLACK": "#ffff00",
  "YELLOW-STRIPED BROWN": "#ffff00",
  "YELLOW-STRIPED WHITE": "#ffff00",
  "YELLOW/BLACK": "#ffff00",
  "YELLOW/BLUE": "#FFFF00",
  "YELLOW/BLUE CHECK": "#FFFF00",
  "YELLOW/GREY": "#ffff00",
  "YELLOW/RED": "#ffff00",
  "YELLOW/WHITE": "#FFFF00",
  "BLACK": "#000000"
};

const colorMap = new Map(Object.entries(colorData));
function findHaxCode(key) {
  return colorMap.has(key) ? colorMap.get(key) : [key, !1];
}


const availableSizeStrings = [
  "0-3 M",
  "3-6 M",
  "0-6 M",
  "6-9 M",
  "9-12 M",
  "6-12 M",
  "12-18 M",
  "18-24 M",
  "1-2 Y",
  "2 Y",
  "2-3 Y",
  "3-4 Y",
  "4-5 Y",
  "5-6 Y",
  "6-7 Y",
  "7-8 Y",
  "8-9 Y",
  "9-10 Y",
  "10-11 Y",
  "11-12 Y",
  "12-13 Y",
  "13-14 Y",
  "Extra Small",
  "Small",
  "Medium",
  "Large",
  "Extra Large",
  "Single",
  "Double",
  "King",
  "XXS",
  "XS",
  "S",
  "M",
  "S/M",
  "L",
  "XL",
  "L/XL",
  "XXL",
  "3XL",
  "EURO-12",
  "EURO-14",
  "EURO-28",
  "EURO-29",
  "EURO-30",
  "EURO-33",
  "EURO-35",
  "EURO-40",
  "EURO-41",
  "EURO-42",
  "EURO-43",
  "EURO-44",
  "EURO-45",
  "10 ML",
  "25 ML",
  "25 ml",
  "30 ML",
  "50 ML",
  "100 ML",
  "26",
  "28",
  "30",
  "32",
  "34",
  "36",
  "38",
  "40",
  "42",
  "44",
  "46",
  "32B",
  "34B",
  "36B",
  "38B",
  "32C",
  "34C",
  "38C",
  "36C",
  "32D",
  "34D",
  "36D",
  "38D",
  "32DD",
  "34DD",
  "36DD",
  "38DD",
  "32E",
  "34E",
  "36E",
  "38E",
  "Free Size",
];

function checkWizzyConfigAndUpdate() {
  window.wizzyConfig &&
    (window.matchMedia("(max-width: 768px)").matches
      ? (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          // dom: "#search_mini_form .wizzy-search-form .input-text", // mobile searchbar
          // type: "text",
          dom: ".site-header__search-container predictive-search .search__input-wrap .search__input", // mobile searchbar
          type: "search",
        })
      : (window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: ".header-item predictive-search .search__input-wrap .search__input", // desktop searchbar
          type: "search",
        }),
    clearInterval(interval));
}
var interval = setInterval(checkWizzyConfigAndUpdate, 100);

var searchIcons = document.querySelectorAll(
  ".site-header .site-nav__icons .js-search-header"
);
searchIcons.length > 0 &&
  searchIcons.forEach((searchIcon) => {
    searchIcon.addEventListener("click", function () {
      var searchInput = document.querySelector(
        ".site-header__search-container predictive-search .search__input-wrap .search__input"
      );
      searchInput &&
        setTimeout(function () {
          searchInput.click();
          searchInput.focus();
        }, 300);
    });
  });

//close button functionality - starts here
if (window.innerWidth < 768) {
  const closeBtn = document.querySelector(
    ".site-header__search-container predictive-search .btn--close-search"
  );
  const searchPopUp = document.querySelector(
    "#SiteHeader .site-header__search-container"
  );
  // const wizzySearchWrapper = document.querySelector(
  //   ".wizzy-main-content .wizzy-search-wrapper"
  // );
  closeBtn.addEventListener("click", function () {
    if (searchPopUp && searchPopUp.classList.contains("is-active")) {
      searchPopUp.classList.remove("is-active");
    }
  });
}

window.innerWidth > 768 &&
  window.addEventListener("scroll", function () {
    var autoCompleteWrapper = document.querySelector(
      ".wizzy-autocomplete-wrapper"
    );
    if (autoCompleteWrapper) {
      var searchInput = document.querySelector(
        ".header-item predictive-search .search__input-wrap .search__input"
      );
      if (searchInput) {
        var positionInfo = searchInput.getBoundingClientRect();
        var left = positionInfo.left;
        var top = positionInfo.top + positionInfo.height;
        autoCompleteWrapper.style.setProperty("top", top + "px", "important");
      }
    }
  });

if (window.innerWidth < 768) {
  window.addEventListener("scroll", function () {
    var autoCompleteWrapper = document.querySelector(
      ".wizzy-autocomplete-wrapper"
    );
    if (autoCompleteWrapper) {
      var searchInput = document.querySelector(
        ".site-header__search-container predictive-search .search__input-wrap .search__input"
      );
      if (searchInput) {
        var positionInfo = searchInput.getBoundingClientRect();
        var left = positionInfo.left;
        var top = positionInfo.top + positionInfo.height;
        autoCompleteWrapper.style.setProperty("top", top + "px", "important");
      }
    }
  });
}

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      if (window.matchMedia("(max-width: 768px)").matches) {
        data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          // dom: "#search_mini_form .wizzy-search-form .input-text", // mobile searchbar
          // type: "text",
          dom: ".site-header__search-container predictive-search .search__input-wrap .search__input", // mobile searchbar
          type: "search",
        };
      } else {
        data.common.lazyDOMConfig.searchInputIdentifiers[0] = {
          dom: ".header-item predictive-search .search__input-wrap .search__input", // desktop searchbar
          type: "search",
        };
      }
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      data.store.currency.symbol = "Rp ";
      console.log("BEFORE_LAZY_INIT");
      return data;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      data.filters.configs.keepOpenedInMobileAfterApply = true;
      data.search.configs.facets.leftFacets.mobileCollapsible = true;
      data.store.currency.symbol = "Rp ";
      // console.log("BEFORE_INIT");
      return data;
    }
  );
  function convertINRtoIDR(price) {
    return price
      .replace(/,/g, ".") // Replace all commas with dots
      .replace(/\.00$/, ""); // Remove trailing ".00" if it exists
  }
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {
  try {
     products?.forEach((product) => {
        if (product?.swatches && product?.swatches?.length) {
          product.swatches[0]?.values?.forEach((swatchData) => {
            swatchData.isSwatch = true;
            swatchData.isURLSwatch = false;
            swatchData.isVisualSwatch = true;
            swatchData.swatch = {
              type: "visual",
              value: swatchData.value ? swatchData.value : "#fff",
            };
         
             swatchData.swatchValue = findHaxCode(swatchData.swatch.value);
               console.log("swatchData : ", swatchData.swatchValue);
            // ? window.wizzyCustomColors[swatchData.value]
            // : "#fff";
          });
        }
      });


      products?.forEach((product) => {
        if (product.sellingPrice) {
          product.sellingPrice = convertINRtoIDR(product.sellingPrice);
        }
        if (product.price) {
          product.price = convertINRtoIDR(product.price);
        }

        if (product.attributes) {
          product?.attributes.forEach((attr) => {
            if (attr.id === "product_vendor") {
              product.vendor = attr.values[0].value[0];
            } else if (attr.id === "product_handle") {
              product.handle = attr.values[0].value[0];
            } else if (attr.id === "product_value_tags_label_on_product_card") {
              product.flashSale = attr.values[0].value[0];
            } else if (attr.id === "product_variant_prices") {
              if (attr.values.length > 1) {
                product.sellingPrice = Math.min(
                  ...attr.values.map((item) => item.value[0])
                ).toLocaleString("id-ID");
              }
            }
          });
        }
      });
  } catch (error) {
    console.log("error",error);
  }
      return products;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (payload) {
      // console.log("BEFORE_AUTOCOMPLETE_EXECUTED");
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (payload) {
      /*code to close search bar in mobile view - starts here*/
      if (window.innerWidth < 768) {
        var siteHeader = document.querySelector(
          ".header-sticky-wrapper .site-header__search-container"
        );
        if (siteHeader && siteHeader.classList.contains("is-active")) {
          siteHeader.classList.remove("is-active");
        }
      } else {
        var predictiveSearchTag = document.querySelector(
          ".header-item predictive-search"
        );
        if (
          predictiveSearchTag &&
          predictiveSearchTag.classList.contains("is-active")
        ) {
          predictiveSearchTag.classList.remove("is-active");
        }
      }
      /*code to close search bar in mobile view - ends here*/

      /*code to remove collection header in search page - starts here */
      var collectionHeader = document.querySelector(
        "#MainContent .shopify-section #CollectionHeaderSection"
      );

      if (collectionHeader) {
        collectionHeader.style.display = "none";
      }
      /*code to remove collection header in search page - ends here */
      // console.log("BEFORE_SEARCH_EXECUTED");
      return payload;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (payload) {
      // console.log("BEFORE_FILTERS_EXECUTED");
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS,
    function (payload) {

   // let n = payload.response.payload.facets.length;
   //    for (let i = 0; i < n; i++) {
   //      if (
   //        payload.response.payload.facets[i].key === "sizes" ||
   //        payload.response.payload.facets[i].key === "product_Size"
   //      ) {
   //        let m = payload.response.payload.facets[i].data.length;
   //        let newArray = [];
   //        for (let ii = 0; ii < availableSizeStrings.length; ii++) {
   //          for (let jj = 0; jj < m; jj++) {
   //            // console.log(data.response.payload.facets[i].data[jj].key);
   //            if (
   //              payload.response.payload.facets[i].data[jj].key ===
   //              availableSizeStrings[ii]
   //            ) {
   //              newArray.push(payload.response.payload.facets[i].data[jj]);
   //            }
   //          }
   //        }
   //               console.log("deep",payload);
   //        payload.response.payload.facets[i].data = newArray;

   //        // break;
   //      } 
   //    }



      
      // console.log("->>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",payload);
      // payload.response.payload.result.forEach((product)=>{
      
      //   if (product.swatches ) {
      //   console.log("inswatches");
      //   console.log(product.swatches);
      //     product.swatches?.colors?.values.forEach((swatchData) =>{ 
      //           console.log("inswatches->>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>",swatchData);
      //       swatchData.isSwatch = true;
      //       swatchData.isURLSwatch = false;
      //       swatchData.isVisualSwatch = true;
      //       swatchData.swatch = {
      //         type: "visual",
      //         value: swatchData.value ? swatchData.value : "#fff",
      //       };
          
      //       //console.log("swatchData : ", swatchData);
      //        swatchData.swatchValue = findHaxCode[swatchData.swatch.value];
      //       // ? window.wizzyCustomColors[swatchData.value]
      //       // : "#fff";
      //     });
      //   }
    
      // });
      if (payload.api === "search" || payload.api === "filter") {
        var facets = payload.response?.payload?.facets;
        facets?.forEach((facet) => {
          if (facet.key === "colors") {
            facet?.data.forEach((item) => {
               let haxcode = findHaxCode(item.key);
              item.isSwatch = true;
              item.isURLSwatch = true;
              item.isVisualSwatch = true;

              item.data = {
                value: item.key,
                swatch: {
                  type: "visual",
                  value: haxcode,
                },
              };
            });
          }
        });
      }
      return payload;
    }
  );
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED,
    function (data) {
      // console.log("VIEW_RENDERED");
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED,
    function (payload) {
      // console.log("PRODUCTS_CACHED_RESULTS_RENDERED");
      return payload;
    }
  );

  changeTemplate("wizzy-autocomplete-topproducts");
  // changeTemplate("wizzy-autocomplete-suggestions");
  // changeTemplate("wizzy-search-wrapper");
  // changeTemplate("wizzy-search-results-product");
};

const changeTemplate = function (div) {
  const oldDiv = document.getElementById(div);
  const newDiv = document.getElementById(div + "-new").text;
  oldDiv.text = newDiv;
};

// Custom Country Dropdown Functionality
document.addEventListener('DOMContentLoaded', function() {
  // Initialize both dropdowns (login and recovery)
  const loginConfig = {
    sectionId: 'login-phone-section',
    containerSelector: '.phone-input-container',
    triggerSelector: '.country-code-trigger',
    menuSelector: '.country-dropdown-menu',
    searchInputSelector: '.search-input',
    listContainerSelector: '.country-list-container',
    selectedCodeSelector: '.selected-country-code',
    hiddenInputSelector: 'input[name="mobileCountryCode"]',
    totalCountSelector: '.total-countries',
    optionClass: 'country-option'
  };
  
  const recoveryConfig = {
    sectionId: 'recovery-phone-section',
    containerSelector: '.phone-input-container',
    triggerSelector: '.country-code-trigger',
    menuSelector: '.country-dropdown-menu',
    searchInputSelector: '.search-input',
    listContainerSelector: '.country-list-container',
    selectedCodeSelector: '.selected-country-code',
    hiddenInputSelector: 'input[name="mobileCountryCode"]',
    totalCountSelector: '.total-countries',
    optionClass: 'country-option'
  };
  
  const accountPhoneConfig = {
    sectionId: 'account-phone-section',
    containerSelector: '.phone-input-container',
    triggerSelector: '.country-code-trigger',
    menuSelector: '.country-dropdown-menu',
    searchInputSelector: '.search-input',
    listContainerSelector: '.country-list-container',
    selectedCodeSelector: '.selected-country-code',
    hiddenInputSelector: 'input[name="mobileCountryCode"]',
    totalCountSelector: '.total-countries',
    optionClass: 'country-option'
  };
  
  const accountPhoneOtpConfig = {
    sectionId: 'account-phone-section-otp',
    containerSelector: '.phone-input-container',
    triggerSelector: '.country-code-trigger',
    menuSelector: '.country-dropdown-menu',
    searchInputSelector: '.search-input',
    listContainerSelector: '.country-list-container',
    selectedCodeSelector: '.selected-country-code',
    hiddenInputSelector: 'input[name="mobileCountryCode"]',
    totalCountSelector: '.total-countries',
    optionClass: 'country-option'
  };
  
  const accountPhonePasswordConfig = {
    sectionId: 'account-phone-section-password',
    containerSelector: '.phone-input-container',
    triggerSelector: '.country-code-trigger',
    menuSelector: '.country-dropdown-menu',
    searchInputSelector: '.search-input',
    listContainerSelector: '.country-list-container',
    selectedCodeSelector: '.selected-country-code',
    hiddenInputSelector: 'input[name="mobileCountryCode"]',
    totalCountSelector: '.total-countries',
    optionClass: 'country-option'
  };
  
  const accountPhoneUpdateConfig = {
    sectionId: 'account-phone-section-update',
    containerSelector: '.phone-input-container',
    triggerSelector: '.country-code-trigger',
    menuSelector: '.country-dropdown-menu',
    searchInputSelector: '.search-input',
    listContainerSelector: '.country-list-container',
    selectedCodeSelector: '.selected-country-code',
    hiddenInputSelector: 'input[name="mobileCountryCode"]',
    totalCountSelector: '.total-countries',
    optionClass: 'country-option'
  };
  
  const registerConfig = {
    sectionId: "register-phone-section",
    containerSelector: ".phone-input-container",
    triggerSelector: ".country-code-trigger",
    menuSelector: ".country-dropdown-menu",
    searchInputSelector: ".search-input",
    listContainerSelector: ".country-list-container",
    selectedCodeSelector: ".selected-country-code",
    hiddenInputSelector: 'input[name="mobileCountryCode"]',
    totalCountSelector: ".total-countries",
    optionClass: "country-option",
  };

  initCountryDropdown(loginConfig);
  initCountryDropdown(recoveryConfig);
  initCountryDropdown(accountPhoneConfig);
  initCountryDropdown(accountPhoneOtpConfig);
  initCountryDropdown(accountPhonePasswordConfig);
  initCountryDropdown(accountPhoneUpdateConfig);
  initCountryDropdown(registerConfig);
});

function initCountryDropdown(config) {
  const section = document.getElementById(config.sectionId);
  if (!section) return;

  const container = section.querySelector(config.containerSelector);
  const trigger = section.querySelector(config.triggerSelector);
  const menu = section.querySelector(config.menuSelector);
  const searchInput = section.querySelector(config.searchInputSelector);
  const listContainer = section.querySelector(config.listContainerSelector);
  const selectedCode = section.querySelector(config.selectedCodeSelector);
  const hiddenInput = section.querySelector(config.hiddenInputSelector);
  const totalCount = section.querySelector(config.totalCountSelector);

  if (!trigger || !menu || !searchInput || !listContainer || !selectedCode || !hiddenInput) return;

  let isOpen = false;
  let allCountries = [];
  let filteredCountries = [];

  // Initialize countries data
  function initCountries() {
    if (!listContainer) return;

    const countryOptions = listContainer.querySelectorAll(
      "." + config.optionClass
    );
    if (!countryOptions || countryOptions.length === 0) return;

    allCountries = Array.from(countryOptions)
      .map((option) => {
        if (!option || !option.dataset) return null;
        return {
          element: option,
          code: option.dataset.code || "",
          name: (option.dataset.name || "").toLowerCase(),
        };
      })
      .filter((country) => country !== null && country.code && country.name);

    filteredCountries = [...allCountries];
    updateTotalCount();

    // Set default selection (+62)
    if (allCountries && allCountries.length > 0) {
      const defaultOption = allCountries.find(
        (country) => country && country.code === "+62"
      );
      if (defaultOption && defaultOption.element) {
        selectCountry(defaultOption.element);
      }
    }
  }

  // Update total count display
  function updateTotalCount() {
    if (totalCount && filteredCountries) {
      const visibleCount = filteredCountries.filter(
        (country) =>
          country &&
          country.element &&
          country.element.classList &&
          !country.element.classList.contains("hidden")
      ).length;
      if (totalCount.textContent !== undefined) {
        totalCount.textContent = `${visibleCount} Countries available`;
      }
    }
  }

  // Toggle dropdown
  function toggleDropdown() {
    if (!menu || !trigger || !searchInput) return;

    isOpen = !isOpen;
    if (isOpen) {
      if (menu.classList) {
        menu.classList.add("show");
      }
      if (trigger.classList) {
        trigger.classList.add("active");
      }
      if (searchInput.focus) {
        searchInput.focus();
      }
      // Reset search and show all countries
      searchInput.value = "";
      filterCountries("");
    } else {
      if (menu.classList) {
        menu.classList.remove("show");
      }
      if (trigger.classList) {
        trigger.classList.remove("active");
      }
    }
  }

  // Filter countries based on search
  function filterCountries(searchTerm) {
    if (!allCountries || allCountries.length === 0) return;

    const term = (searchTerm || "").toLowerCase().trim();

    for (const country of allCountries) {
      if (!country || !country.element || !country.element.classList) continue;

      const matchesSearch =
        term === "" ||
        (country.name && country.name.includes(term)) ||
        (country.code && country.code.toLowerCase().includes(term));

      if (matchesSearch) {
        country.element.classList.remove("hidden");
      } else {
        country.element.classList.add("hidden");
      }
    }

    filteredCountries = allCountries.filter(
      (country) =>
        country &&
        country.element &&
        country.element.classList &&
        !country.element.classList.contains("hidden")
    );
    updateTotalCount();
  }

  // Select a country
  function selectCountry(countryElement) {
    if (!countryElement || !countryElement.dataset) return;

    const code = countryElement.dataset.code;
    if (!code) return;

    // Update selected display
    if (selectedCode) {
      selectedCode.textContent = code;
    }
    if (hiddenInput) {
      hiddenInput.value = code;
    }

    // Update visual selection
    if (allCountries && allCountries.length > 0) {
      for (const country of allCountries) {
        if (country && country.element && country.element.classList) {
          country.element.classList.remove("selected");
        }
      }
    }
    if (countryElement.classList) {
      countryElement.classList.add("selected");
    }

    // Close dropdown
    isOpen = false;
    if (menu && menu.classList) {
      menu.classList.remove("show");
    }
    if (trigger && trigger.classList) {
      trigger.classList.remove("active");
    }
    if (searchInput) {
      searchInput.value = "";
    }

    // Reset filter
    filterCountries("");
  }

  // Event listeners
  if (trigger) {
    trigger.addEventListener("click", function (e) {
      if (!e) return;
      e.stopPropagation();

      // Check if dropdown should be disabled (for account-phone-section-update)
      if (config.sectionId === "account-phone-section-update" && section) {
        const phoneInput = section
          .closest("form")
          ?.querySelector('input[name="mobileNumber"]');
        if (phoneInput && phoneInput.disabled) {
          return; // Don't open dropdown if input is disabled
        }
      }

      toggleDropdown();
    });
  }

  if (searchInput) {
    searchInput.addEventListener("input", function (e) {
      if (!e || !e.target) return;
      filterCountries(e.target.value);
    });

    searchInput.addEventListener("keydown", function (e) {
      if (!e) return;
      if (e.key === "Escape") {
        toggleDropdown();
      }
    });
  }

  // Handle country selection
  if (listContainer) {
    listContainer.addEventListener("click", function (e) {
      if (!e || !e.target) return;

      const countryRadio = e.target.closest(".country-radio");
      const countryOption = e.target.closest("." + config.optionClass);

      if (countryOption && countryOption.classList) {
        const isHidden = countryOption.classList.contains("hidden");
        if ((countryRadio || countryOption) && !isHidden) {
          selectCountry(countryOption);
        }
      }
    });
  }

  // Close dropdown when clicking outside
  document.addEventListener("click", function (e) {
    if (!e || !section) return;

    if (isOpen && !section.contains(e.target)) {
      isOpen = false;
      if (menu && menu.classList) {
        menu.classList.remove("show");
      }
      if (trigger && trigger.classList) {
        trigger.classList.remove("active");
      }
      if (searchInput) {
        searchInput.value = "";
      }
      filterCountries("");
    }
  });

  // Initialize
  initCountries();
}
